import _ from "lodash";
import i18n from 'i18next';
import { itemAccessors } from "./constants";
import { round } from "./format";

const matchValue = (columnId, rowValue, filterValue) => {
    //Some values in the json are different as the value display
    //For filter options with use user inputs
    //Use the same value that is displayed
    //Format number or translate
    // console.log(columnId, rowValue, filterValue)
    if (rowValue === null || rowValue === undefined) {
      return false;
    } else if (Array.isArray(rowValue)) {
      return rowValue.some( item =>
        matchValue(columnId, item, filterValue)
      )
    } else if (typeof rowValue === 'object') {
      return Object.keys(rowValue).some( key =>
        matchValue(key, rowValue[key], filterValue)
      )
    } else if (
      _.includes(
        [itemAccessors.netFlowPriority, itemAccessors.currentOnHandAlert],
        columnId
      )
    ) {
      return !_.isNaN(round(rowValue * 100, 2))
        ? `${round(rowValue * 100, 2)}%`.startsWith(filterValue)
        : false;
    } else if ( _.isNumber(rowValue) ){
      return rowValue.toFixed(2).startsWith(filterValue);
    } else if (columnId === itemAccessors.worstBatchStatus) {
      return i18n.t(`retail.batchStatus.${rowValue}`).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
    } else if (columnId === itemAccessors.materialMethod) {
      return i18n.t(`ordersTable.method.${rowValue}`).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
    } else if (columnId === itemAccessors.bufferZoneColor) {
      return i18n.t(`ordersTable.columns.${rowValue}`).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
    } else if (columnId === "reasonCode") {
      return i18n.t(`ordersTable.reasonCodes.${rowValue}`).toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
    }
    return rowValue.toLocaleLowerCase().includes(filterValue.toLocaleLowerCase());
  };

export const equalsAny = (rows, ids, filterValues) => {
  const filterSet = new Set(filterValues);
  return rows.filter(row => {
    return ids.some(id => filterSet.has(row.values[id]));
  });
};

export const includesPartial = (rows, ids, filterValues) => {
  if(Array.isArray(filterValues) && filterValues.length > 0 && filterValues[0] !== ''){
    return rows.filter(row => {
      return ids.some(id => {
        const val = row.values[id];
        if (val === null || val === undefined) return false;
        return matchValue(id, val, filterValues[0]);
      });
    });
  }
  return rows
};

//The way that iterate is:
//First go over every row and then over every column of this row
//And then check if the value of the cell is equal to filterValues
//Return a row or array of rows that match the filter
export const multipleOptions = (rows, ids, filterValues) => {
  if(Array.isArray(filterValues)){
    const filterSet = new Set(filterValues);
    //Iterate over every row
    return rows.filter(row => {
      //Iterate over every column of this row
      return ids.some(id => filterSet.has(row.values[id]));
    });
  }
}

export const multipleRowOptions = (rows, ids, filterValues) => {
  if(Array.isArray(filterValues) && filterValues.length > 0 && filterValues[0] !== '') {
    //Iterate over every row
    return rows.filter(row => {
      //Iterate over every column of this row
      return ids.every((id, index) => {
        // Get the value of the cell
        const rowValue = row.values[id];
        return filterValues[index].includes(rowValue);
      })
    });
  }
  return rows
}
